// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__EBcly","error":"Input_error__TpfBX","error-text":"Input_error-text__qF8U4"};